import gql from 'graphql-tag'
import client from '@stores/apollo'
import { BuildingTypeFragment } from '@api/fragments'
import { IBuildingType } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  createBuildingType: {
    buildingType: IBuildingType
  }
}

const mutateHandler = handleFetchResult<IPayload, IBuildingType>({
  handler: (data) => data.createBuildingType.buildingType,
  name: 'Building Type',
})

export default function create(name: string) {
  return client.gql
    .mutate<IPayload>({ mutation, variables: { input: { displayName: name } } })
    .then(mutateHandler)
}

const mutation = gql`
  mutation createBuildingType($input: CreateBuildingTypeInput!) {
    createBuildingType(input: $input) {
      buildingType {
        ...BuildingTypeFragment
      }
    }
  }
  ${BuildingTypeFragment}
`
